<template>
    <v-card tile>
        <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        >
            <v-tab>Personal Information</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="personalform">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="First Name" rules="required">
                                                <v-text-field
                                                v-model="form.first_name"
                                                :error-messages="errors"
                                                label="First Name"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Last Name" rules="required">
                                                <v-text-field
                                                v-model="form.last_name"
                                                :error-messages="errors"
                                                label="Last Name"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Email" rules="email">
                                                <v-text-field
                                                v-model="form.email"
                                                :error-messages="errors"
                                                label="E-mail"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <v-text-field
                                                v-model="form.phone"
                                                label="Phone"
                                                required
                                            ></v-text-field>
                                            <v-text-field
                                                v-model="form.phone_2"
                                                label="Phone 2"
                                                required
                                            ></v-text-field>
                                            <ValidationProvider v-slot="{ errors }" name="Street Address" rules="required">
                                                <v-text-field
                                                v-model="form.street_address"
                                                :error-messages="errors"
                                                label="Street Address"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="City" rules="required">
                                                <v-text-field
                                                v-model="form.city"
                                                :error-messages="errors"
                                                label="City"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="State" rules="required">
                                                <v-select
                                                    v-model="form.state"
                                                    :items="states"
                                                    item-text="label"
                                                    item-value="value"
                                                    :error-messages="errors"
                                                    label="Select a State"
                                                    data-vv-name="state"
                                                    required
                                                ></v-select>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Zip Code" rules="required">
                                                <v-text-field
                                                v-model="form.zip"
                                                :error-messages="errors"
                                                label="Zip Code"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                           <v-text-field
                                                v-model="form.pricing"
                                                label="Pricing"
                                                required
                                            ></v-text-field>
                                            <v-textarea
                                                v-model="form.note"
                                                label="Notes"
                                            ></v-textarea>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>                        
                        <v-btn large min-width="50%" color="blue darken-1" text to="/customers">Cancel</v-btn>              
                        <v-btn large min-width="50%" color="primary" tile @click="submit" :loading="loading">Update</v-btn>
                    </v-card-actions>
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    data () {
        return {
            tab: null,
            form: {
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                phone_2: '',
                street_address: '',
                city: '',
                state: 'AL',
                zip: '',
                service: 'Cleaning',
                county: null,
                pricing: '',
                note: ''
            },
        }
    },

    computed: {
        ...mapGetters({
            counties: 'data/counties',
            states: 'data/states',
        }),
    },
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    methods: {
        ...mapActions({
            addCustomer: 'data/addCustomer'
        }),
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.addCustomer(this.form).then(response => {
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    if(this.$route.params.redirect == 'Dashboard') {
                        this.$router.push({ name: this.$route.params.redirect, params: { customer: response.customer } })
                    } else {
                        this.$router.push({ path: `/customer/${response.id}` })
                    }
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
    }
}
</script>
<style lang="sass" scoped>
.estimation
    background: #003e72
    color: #fff
    text-align: center
    justify-content: center
    font-size: 20px
    margin: -16px -16px 20px
header
    &.quote-bar
        position: sticky
        top: 0
        z-index: 999
</style>